import {
  DropsOperationLevel,
  FormErrorWithDiscriminatedField,
  FormSchema,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Field,
  FieldErrorText,
  Radio,
  RadioGroup,
} from "shared/components/Spor";

export const StationDropsOperationReduced: FC = () => {
  const { t } = useTranslation();
  const { watch, setValue, clearErrors, formState } =
    useFormContext<FormSchema>();
  const level = watch("stationForm.level");
  const fieldErrors: FormErrorWithDiscriminatedField<"level"> =
    formState.errors.stationForm;

  return (
    <Field as="fieldset" invalid={!!fieldErrors?.level}>
      <Field as="legend">{t("Velg nivå")}</Field>

      <RadioGroup
        name="level"
        value={level}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const value = e.target.value as DropsOperationLevel;
          setValue("stationForm.level", value);
          clearErrors("stationForm.level");
        }}
      >
        <Radio value="RED">{t("Rød")}</Radio>
        <Radio value="YELLOW">{t("Gul")}</Radio>
      </RadioGroup>

      <FieldErrorText marginTop="12px">
        {fieldErrors?.level?.message}
      </FieldErrorText>
    </Field>
  );
};
